import { colorNeutralBackground2, colorNeutralForeground1, colorNeutralStroke1, display, spacingHorizontalXXL, spacingVerticalL, spacingVerticalXS, spacingVerticalXXL } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
/** Wizard Panel styles
 * @public
 */
export const styles = css `
  ${display("block")}
  :host {
    height: 100%;
    background: ${colorNeutralBackground2};
  }

  :host([active]) {
    display: block;
  }

  .content {
    padding-block-start: ${spacingVerticalXXL};
    padding-inline: ${spacingHorizontalXXL};
    padding-block-end: 0;
  }

  .title {
    padding-block-start: 0;
    padding-inline: ${spacingHorizontalXXL};
    padding-block-end: ${spacingVerticalXS};
    color: ${colorNeutralForeground1};
  }
  .footer {
    padding-block: ${spacingVerticalL};
    padding-inline: ${spacingHorizontalXXL};
    border-top: 1px solid ${colorNeutralStroke1};
  }
`;
//# sourceMappingURL=wizard-panel.styles.js.map